import { useEffect, useState } from "react";
import { useGetList } from "react-admin";

/**
 * Options of a pre-filter autocomplete searched on the server, like <ReferenceInput> + <AutocompleteInput>: the
 * typed text (3+ characters, debounced) is sent as `searchKey` together with `filter`. Spread the result into the
 * CustomFilter field:
 *
 *   const rooms = useSearchChoices({ request: administrationRequests.getRoomsSelect(), filter: { buildingId } });
 *   { label: "Зала", type: "autocomplete", value, setValue, ...rooms }
 *
 * Returns `choices` and `onInputChange` (the CustomFilter autocomplete then skips its own client-side filtering).
 */
const useSearchChoices = ({ request, filter = {}, searchKey = "name", enabled = true }) => {
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => setSearch(input), 300);
    return () => clearTimeout(timeout);
  }, [input]);

  // A disabled hook belongs to a hidden field. Drop its search, or the field remounts with an empty input but
  // choices still filtered by the old text (MUI fires no onInputChange on mount, the input already being "").
  useEffect(() => {
    if (enabled) return;
    setInput("");
    setSearch("");
  }, [enabled]);

  const { data } = useGetList(
    request,
    { pagination: { page: 1, perPage: 25 }, filter: { ...filter, ...(search.length > 2 && { [searchKey]: search }) } },
    { enabled },
  );

  return { choices: data ?? [], onInputChange: setInput };
};

export default useSearchChoices;
